/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
} from './Message';
import type { PayloadTypeConstants } from './PayloadTypeConstants';
import {
    PayloadTypeConstantsFromJSON,
    PayloadTypeConstantsFromJSONTyped,
    PayloadTypeConstantsToJSON,
} from './PayloadTypeConstants';

/**
 * 
 * @export
 * @interface EmptyResponse
 */
export interface EmptyResponse {
    /**
     * 
     * @type {PayloadTypeConstants}
     * @memberof EmptyResponse
     */
    type: PayloadTypeConstants;
    /**
     * 
     * @type {Array<Message>}
     * @memberof EmptyResponse
     */
    messages: Array<Message>;
    /**
     * 
     * @type {string}
     * @memberof EmptyResponse
     */
    openInNewWindowUri?: string;
    /**
     * 
     * @type {any}
     * @memberof EmptyResponse
     */
    payload?: any;
}

/**
 * Check if a given object implements the EmptyResponse interface.
 */
export function instanceOfEmptyResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "messages" in value;

    return isInstance;
}

export function EmptyResponseFromJSON(json: any): EmptyResponse {
    return EmptyResponseFromJSONTyped(json, false);
}

export function EmptyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmptyResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': PayloadTypeConstantsFromJSON(json['type']),
        'messages': ((json['messages'] as Array<any>).map(MessageFromJSON)),
        'openInNewWindowUri': !exists(json, 'openInNewWindowUri') ? undefined : json['openInNewWindowUri'],
        'payload': !exists(json, 'payload') ? undefined : json['payload'],
    };
}

export function EmptyResponseToJSON(value?: EmptyResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': PayloadTypeConstantsToJSON(value.type),
        'messages': ((value.messages as Array<any>).map(MessageToJSON)),
        'openInNewWindowUri': value.openInNewWindowUri,
        'payload': value.payload,
    };
}

